import React, { useState,useRef, useMemo } from "react";
import { Container, Row, Col, Card, CardBody, Input, Button, FormFeedback, ModalFooter, Modal, ModalBody, } from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import { withTranslation } from "react-i18next";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

import Snackbars from "../../Utils/Snackbars";
import { checkImageValidation } from "../../Utils/Common";
import useRequests from '../../Utils/useRequests';
import 'jodit/es5/jodit.min.css'; 
import JoditEditor from 'jodit-react'; 

const Edit_Property = props => {
  //meta title
  document.title = "Edit Property";
  const history = useHistory();
  const { getRequest, postRequest, postRequestByFormData } = useRequests();

  const editorConfig = useMemo(() => ({
    readonly: false,
    toolbar: true,
    autofocus: true,
    showSource: true,
    uploader: {
      insertImageAsBase64URI: true,
    },
    width: '1400px',
    height: '601px',
    buttons: [
      'bold', 'italic', 'underline', 'strikethrough',  '|',
      'font', 'fontsize', 'paragraph', 'align', 'list', '|',
      'link', 'image', 'table', 'undo', 'redo', 'cut', 'copy', 'paste',  '|',
      'source', 'preview',
    ],
    allowedTags: ['*'],
    allowAttributes: {
      '*': ['*'], 
    },
    cleanHTML: false,
  }), []);

  const [AlertData, setAlertData] = React.useState({
		variant: '',
		message: '',
	});
	const resetAlertData = () => {
		setTimeout(() => {
			setAlertData((AlertData) => ({
				...AlertData,
				variant: '',
				message: '',
			}));
		}, 5000);
	};

  
  const [file, setFile] = useState();
  const [fileName, setFileName] = useState('');
  const saveFile = (e) => {
    if((e.target.files).length > 0) {
      setFile(e.target.files[0]);
      setFileName(e.target.files[0].name);

      var imageValidationRes = checkImageValidation(e.target.files[0]);
      if (imageValidationRes.status) {
          var url = URL.createObjectURL(e.target.files[0]);
          var img = new Image;
          var width = 1920;
          var height = 1080;
          img.onload = function () {
              if (img.width < 1910 || img.width > 1930 && img.height < 1070 || img.height > 1090) {
                setFile();
                setFileName('');
                
                setAlertData((AlertData) => ({
                  ...AlertData,
                  variant: 'error',
                  message: 'Image perfect size is ' + width + ' * ' + height,
                }));
                resetAlertData();
              }
              URL.revokeObjectURL(img.src);
          };
          img.src = url;
      } else {
        setFile();
        setFileName('');

        setAlertData((AlertData) => ({
          ...AlertData,
          variant: 'error',
          message: imageValidationRes.msg,
        }));
        resetAlertData();

        return false;
      }
    }
  };

  const handleUploadImage = async (e) => {
    if (fileName === '') {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: 'Please select a image with a valid image size!',
      }));
      resetAlertData();

      return false;
    } else {
        let submit1 = document.getElementById('submit3');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        const formData = new FormData();
        formData.append("p_id", atob(props.match.params.id));
        formData.append("file", file);
        formData.append("fileName", fileName);
        const res = await postRequestByFormData('add-property-image', formData);
        if (res && res.code === 200) {
          handleLoadGetPropertyImages();

          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'success',
            message: res.message,
          }));
        }
        else {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: res.message,
          }));
        }
        resetAlertData();

        submit1.disabled = false;
        submit1.textContent = 'Upload';
    }
  }

  const handleDeleteImage = async (pi_id, image) => {
    const jsonpar = JSON.stringify({
      pi_id: atob(pi_id),
      p_id: atob(props.match.params.id),
      image: image,
    });
    const res = await postRequest('delete-property-image', jsonpar);
    if (res && res.code === 200) {
      handleLoadGetPropertyImages();

      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'success',
        message: res.message,
      }));
    }
    else {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }

  const [coverFile, setCoverFile] = useState();
  const [coverFileName, setCoverFileName] = useState('');
  const saveCoverFile = (e) => {
    if((e.target.files).length > 0) {
      setCoverFile(e.target.files[0]);
      setCoverFileName(e.target.files[0].name);

      var imageValidationRes = checkImageValidation(e.target.files[0]);
      if (imageValidationRes.status) {
          var url = URL.createObjectURL(e.target.files[0]);
          var img = new Image;
          var width = 1920;
          var height = 1080;
          img.onload = function () {
              if (img.width < 1910 || img.width > 1930 && img.height < 1070 || img.height > 1090) {
                setCoverFile();
                setCoverFileName('');
                
                setAlertData((AlertData) => ({
                  ...AlertData,
                  variant: 'error',
                  message: 'Image perfect size is ' + width + ' * ' + height,
                }));
                resetAlertData();
              }
              URL.revokeObjectURL(img.src);
          };
          img.src = url;
      } else {
        setCoverFile();
        setCoverFileName('');

        setAlertData((AlertData) => ({
          ...AlertData,
          variant: 'error',
          message: imageValidationRes.msg,
        }));
        resetAlertData();

        return false;
      }
    }
  };

  const handleUploadCoverImage = async (e) => {
    if (coverFileName === '') {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: 'Please select a image with a valid image size!',
      }));
      resetAlertData();

      return false;
    } else {
        let submit1 = document.getElementById('submit4');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        const formData = new FormData();
        formData.append("p_id", atob(props.match.params.id));
        formData.append("file", coverFile);
        formData.append("fileName", coverFileName);
        formData.append("currentFileName", validation1.values.cover_image);
        const res = await postRequestByFormData('add-property-cover-image', formData);
        if (res && res.code === 200) {
          handleLoadGetPropertyInfo(PreferredLanguage);

          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'success',
            message: res.message,
          }));
        }
        else {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: res.message,
          }));
        }
        resetAlertData();

        submit1.disabled = false;
        submit1.textContent = 'Upload';
    }
  }

  const handleDeleteCoverImage = async (cover_image) => {
    const jsonpar = JSON.stringify({
      p_id: atob(props.match.params.id),
      cover_image: cover_image,
    });
    const res = await postRequest('delete-property-cover-image', jsonpar);
    if (res && res.code === 200) {
      handleLoadGetPropertyInfo(PreferredLanguage);

      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'success',
        message: res.message,
      }));
    }
    else {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }
  
  const validation2 = useFormik({
    enableReinitialize: true,

    initialValues: {
      token_price: '',
      total_token: '',
      minimum_investment_allocation: '',
      lock_in_period_no: '1',
      lock_in_period: 'year',
      profitability: '',
    },
    validationSchema: Yup.object({
      token_price: Yup.string()
        .matches(
          /^[#0-9.]+$/,
          'Please enter a valid value!'
        )
        .required('Token Price is required'),
      total_token: Yup.string()
        .matches(
          /^[#0-9]+$/,
          'Please enter a valid value!'
        )
        .required('Total Token is required'),
      minimum_investment_allocation: Yup.string()
        .matches(
          /^[#0-9.]+$/,
          'Please enter a valid value!'
        )
        .required('Minimum Investment Allocation is required'),
      lock_in_period_no: Yup.string()
        .matches(
          /^[#0-9]+$/,
          'Please enter a valid value!'
        )
        .required('Lock in Period No is required'),
      lock_in_period: Yup.string().required('Please select lock in period'),
      profitability: Yup.string()
      .matches(
        /^[#0-9.]+$/,
        'Please enter a valid value!'
      )
      .required('Profitability is required'),
    }),
    onSubmit: async (values) => {
      try {
        let submit1 = document.getElementById('submit2');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        const jsonpar = JSON.stringify({
          p_id: atob(props.match.params.id),
          token_price: values.token_price,
          total_token: values.total_token,
          minimum_investment_allocation: values.minimum_investment_allocation,
          lock_in_period_no: values.lock_in_period_no,
          lock_in_period: values.lock_in_period,
          profitability: values.profitability,
        });
        const res = await postRequest('update-property-token-info', jsonpar);
        if (res && res.code === 200) {
          history.push({
            pathname: '/property',
            state: { code: 200, status: 'success', message: res.message }
          });
        }
        else {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: res.message,
          }));
        }
        resetAlertData();

        submit1.disabled = false;
        submit1.textContent = 'Update';
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });

  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      property_name: '',
      property_sub_title: '',
      property_description: '',
      property_impact: '',
      property_developer: '',
      property_address: '',
      latitude: '',
      longitude: '',
      status: '',
      property_status: '',
      cover_image: '',
    },
    validationSchema: Yup.object({
      property_name: Yup.string().required('Property name is required'),
      property_sub_title: Yup.string().required('Property sub title is required'),
      property_description: Yup.string().required('Description is required'),
      property_impact: Yup.string().required('Property Impact is required'),
      property_developer: Yup.string().required('Property Developer is required'),
      property_address: Yup.string().required('Address is required'),
      latitude: Yup.string().required('Latitude is required'),
      longitude: Yup.string().required('Longitude is required'),
      status: Yup.string().required('Please select status'),
      property_status: Yup.string().required('Please select property status'),
    }),
    onSubmit: async (values) => {
      try {
        if (values.property_description === "" || values.property_description == null) {
          validation1.setFieldError("property_description", "Description is required");
          return;
        }else if(values.property_impact === "" || values.property_impact == null){
          validation1.setFieldError("property_impact", "Property Impact is required");
          return;
        }else if(values.property_developer === "" || values.property_developer == null){
          validation1.setFieldError("property_developer", "Property Developer is required");
          return;
        }

        let submit1 = document.getElementById('submit1');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        const jsonpar = JSON.stringify({
          p_id: atob(props.match.params.id),
          property_name: values.property_name,
          property_sub_title: values.property_sub_title,
          property_description: values.property_description,          
          property_impact: values.property_impact,
          property_developer: values.property_developer,
          property_address: values.property_address,
          latitude: values.latitude,
          longitude: values.longitude,
          status: values.status,
          property_status: values.property_status,
          lang: PreferredLanguage
        });
        const res = await postRequest('update-property', jsonpar);
        if (res && res.code === 200) {
          history.push({
            pathname: '/property',
            state: { code: 200, status: 'success', message: res.message }
          });
        }
        else {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: res.message,
          }));
        }
        resetAlertData();

        submit1.disabled = false;
        submit1.textContent = 'Update';
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });

  const validation3 = useFormik({
    enableReinitialize: true,

    initialValues: {
      property_website: '',
      property_instagram: ''
    },
    
    validationSchema: Yup.object({
      property_website: Yup.string().required('Website is required'),
      property_instagram: Yup.string().required('Instagram profile is required')
    }),
    onSubmit: async (values) => {
      try {
  
        let submit3 = document.getElementById('submit3');
        submit3.disabled = true;
        submit3.textContent = 'Processing...';

        const jsonpar = JSON.stringify({
          p_id: atob(props.match.params.id),
          property_website: values.property_website,
          property_instagram: values.property_instagram
        });
        const res = await postRequest('update-property-site-info', jsonpar);
        if (res && res.code === 200) {
          history.push({
            pathname: '/property',
            state: { code: 200, status: 'success', message: res.message }
          });
        }
        else {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: res.message,
          }));
        }
        resetAlertData();

        submit3.disabled = false;
        submit3.textContent = 'Update';
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });
  
  const [impactDoc, setImpactDoc] = React.useState('');
  const [CoverImageURL, setCoverImageURL] = useState('');
  const handleLoadGetPropertyInfo = async (lang) => {
    const jsonpar = JSON.stringify({
      p_id: atob(props.match.params.id),
    });
    const res = await postRequest('get-property-info', jsonpar);
    if (res && res.code === 200) {
      let originalText = res.data.property;

      if(lang=="en"){
        descriptionContentRef.current=originalText.property_description;
        impactContentRef.current=originalText.property_impact;
        developerContentRef.current=originalText.property_developer;

        validation1.setValues({
          ...validation1.values,
          property_name: originalText.property_name,
          property_sub_title: originalText.property_sub_title,
          property_address: originalText.property_address,
          property_description: originalText.property_description,
          property_impact: originalText.property_impact,
          property_developer: originalText.property_developer,
          latitude: originalText.latitude,
          longitude: originalText.longitude,
          property_website: originalText.property_website,
          property_instagram: originalText.property_instagram,
          status: originalText.status,
          property_status: originalText.property_status,
          cover_image: originalText.cover_image,
        });
        validation5.setValues({
          ...validation2.values,
          p_id: originalText.p_id,
          impact_document_name: originalText.impact_document_name,
        })
      }else{
        descriptionContentRef.current=originalText.translated_property_description;
        impactContentRef.current=originalText.translated_property_impact;
        developerContentRef.current=originalText.translated_property_developer;

        validation1.setValues({
          ...validation1.values,
          property_name: originalText.translated_property_name,
          property_sub_title: originalText.translated_property_sub_title,
          property_address: originalText.translated_property_address,
          property_description: originalText.translated_property_description,
          property_impact: originalText.translated_property_impact,
          property_developer: originalText.translated_property_developer,
          latitude: originalText.latitude,
          longitude: originalText.longitude,
          property_website: originalText.property_website,
          property_instagram: originalText.property_instagram,
          status: originalText.status,
          property_status: originalText.property_status,
          cover_image: originalText.cover_image,
        });
        validation5.setValues({
          ...validation2.values,
          p_id: originalText.p_id,
          impact_document_name: originalText.impact_document_name_sp,
        })
      }

      validation2.setValues({
        ...validation2.values,
        token_price: originalText.token_price,
        total_token: originalText.total_token,
        minimum_investment_allocation: originalText.minimum_investment_allocation,
        lock_in_period_no: originalText.lock_in_period_no,
        lock_in_period: originalText.lock_in_period,
        profitability: originalText.profitability,
      });

      validation3.setValues({
        ...validation3.values,
        property_website: originalText.property_website,
        property_instagram: originalText.property_instagram
      });

      setImpactDoc(process.env.REACT_APP_API_URL+res.data.docUrl+originalText.impact_document)

      const filePath = res.data.url;
      
      setCoverImageURL('');
      if(originalText.cover_image) {
        let imageUrl = `${process.env.REACT_APP_API_URL}${filePath}${originalText.cover_image}`;
        setCoverImageURL(<div className="multiimg">
          <img src={imageUrl} alt={`Cover Image`} />
          <i className="mdi mdi-close" onClick={(e) => handleDeleteCoverImage(originalText.cover_image)}></i>
        </div>);
      }
    }
    else {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }
  const [ImageGallery, setImageGallery] = useState('');
  const handleLoadGetPropertyImages = async () => {
    const jsonpar = JSON.stringify({
      p_id: atob(props.match.params.id)
    });
    const res = await postRequest('get-property-images', jsonpar);
    if (res && res.code === 200) {
      let originalText = res.data.images;
      
      const filePath = res.data.url;

      let tempTBody = originalText.map((element, index) => {
        const imageUrl = `${process.env.REACT_APP_API_URL}${filePath}${element.image}`;
        return (
          <div key={index} className="multiimg">
            <img src={imageUrl} alt={`Image ${index}`} />
            <i className="mdi mdi-close" onClick={(e) => handleDeleteImage(btoa(element.pi_id), element.image)}></i>
          </div>
        );
      });

      setImageGallery(tempTBody);
    }
    else {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }

  const descriptionContentRef = useRef(validation1.values.property_description); 
  const impactContentRef = useRef(validation1.values.property_impact); 
  const developerContentRef = useRef(validation1.values.property_developer); 

  const handleDescriptionChange = (newContent) => {
    if (newContent !== descriptionContentRef.current) {
      descriptionContentRef.current = newContent;
    }
  };
    const handleImpactChange = (newContent) => {
    if (newContent !== impactContentRef.current) {
      impactContentRef.current = newContent;
    }
  };
  const handleDeveloperChange = (newContent) => {
    if (newContent !== developerContentRef.current) {
      developerContentRef.current = newContent;
    }
  };
  const handleSubmit = async () => {
    await validation1.setValues({
      ...validation1.values,
      property_description: descriptionContentRef.current,
      property_impact: impactContentRef.current,
      property_developer: developerContentRef.current
    });
  };

  const [PreferredLanguage, setPreferredLanguage] = React.useState('en');
  const onChangePreferredLanguage = (e) => {
    setPreferredLanguage(e.target.value);
    handleLoadGetPropertyInfo(e.target.value);
  };

  const [StandardModal2, setStandardModal2] = React.useState(false)
  const [impactfile, setImpactFile] = useState()
  const [impactfileName, setImpactFileName] = useState("")
  const saveImpactFile = e => {
    if (e.target.files.length > 0) {
      setImpactFile(e.target.files[0])
      setImpactFileName(e.target.files[0].name)
    }
  }
  const handleImpactUploadDoc = async e => {
    if (impactfileName === "") {
      setAlertData(AlertData => ({
        ...AlertData,
        variant: "error",
        message: "Please select new document!",
      }))
      resetAlertData()

      return false
    } else {
      let submit5 = document.getElementById("submit5")
      submit5.disabled = true
      submit5.textContent = "Processing..."

      const formData = new FormData()
      formData.append("p_id", atob(props.match.params.id))
      formData.append("file", impactfile)
      formData.append("fileName", impactfileName)
      const res = await postRequestByFormData(
        "update-impact-document",
        formData,
      )
      if (res && res.code === 200) {
        handleLoadGetPropertyInfo(PreferredLanguage)

        setAlertData(AlertData => ({
          ...AlertData,
          variant: "success",
          message: res.message,
        }))
      } else {
        setAlertData(AlertData => ({
          ...AlertData,
          variant: "error",
          message: res.message,
        }))
      }
      resetAlertData()

      submit5.disabled = false
      submit5.textContent = "Upload"
    }
  }

  const validation5 = useFormik({
    enableReinitialize: true,

    initialValues: {
      impact_document_name : "",
    },
    validationSchema: Yup.object({
      impact_document_name : Yup.string().required("Please select document name"),
    }),
    onSubmit: async values => {
      try {
        let submit6 = document.getElementById("submit6")
        submit6.disabled = true
        submit6.textContent = "Processing..."
        const formData = new FormData()
        formData.append("p_id", atob(props.match.params.id))
        formData.append("impact_document_name", values.impact_document_name )
        formData.append("lang", PreferredLanguage)
        const res = await postRequestByFormData(
          "update-impact-document-details",
          formData,
        )

        if (res && res.code === 200) {
          handleLoadGetPropertyInfo(PreferredLanguage)

          setAlertData(AlertData => ({
            ...AlertData,
            variant: "success",
            message: res.message,
          }))
        } else {
          setAlertData(AlertData => ({
            ...AlertData,
            variant: "error",
            message: res.message,
          }))
        }
        resetAlertData()

        submit6.disabled = false
        submit6.textContent = "Add"

        setStandardModal2(false)
      } catch (error) {
        console.error("Error : ", error)
      }
    },
  })


  React.useEffect(() => {
    if (!props.match.params.id) {
      history.push({
        pathname: '/property',
        state: { code: 401, status: 'error', message: 'ID not found! Please provide a valid ID.' }
      });
		}
    else {
      handleLoadGetPropertyInfo('en');
      handleLoadGetPropertyImages();
      setTimeout(() => {
        handleLoadGetPropertyInfo('en');
        handleLoadGetPropertyImages();
      }, 500);
    }
  }, []);

  
  return (
    <React.Fragment>
			{AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={props.t("Eshepay")} breadcrumbItem={props.t("Edit Property")} />
          <Row>
            <Col lg="12">
              <Card>              
                <CardBody>
                  <Col xs="12" className="mb-2 cstm-fullWidth">
                    <div className="add-form"> </div>
                    <div className="lang-select">
                      <select className="form-select top-right-lang" name="preferred_language" value={PreferredLanguage} onChange={(e) => onChangePreferredLanguage(e)}>
                        <option value={'en'}>English</option>
                        <option value={'sp'}>Spanish</option>
                      </select>
                      <i className="fas fa-angle-down"></i>
                    </div>
                    <Link className="back-link-2" to="/property"><i className="bx bx-left-arrow-alt"></i> Back</Link>
                  </Col>
                  {/* <Button type="button" color="primary" > Update </Button> */}
                  <div className="mb-4 h4 card-title cstm-fullWidth">Property Details</div>
                  <Col xs="12" className="cstm-fullWidth">
                    <div className="row mb-3">
                      <Col md={4} xs={12}>
                        <div className="mb-3">
                          <label className="form-label">Property Name	:</label>
                          <Input
                            name="property_name" 
                            type="text" 
                            placeholder={'Enter Property Name'}
                            onChange={validation1.handleChange}
                            onBlur={validation1.handleBlur}
                            value={validation1.values.property_name || ""}
                            invalid={
                              validation1.touched.property_name && validation1.errors.property_name ? true : false
                            }
                          />
                          {validation1.touched.property_name && validation1.errors.property_name ? (
                            <FormFeedback type="invalid">{validation1.errors.property_name}</FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col md={4} xs={12}>
                        <div className="mb-3">
                          <label className="form-label">Property Sub Title	:</label>
                          <Input
                            name="property_sub_title" 
                            type="text" 
                            placeholder={'Enter Property Sub Title'}
                            onChange={validation1.handleChange}
                            onBlur={validation1.handleBlur}
                            value={validation1.values.property_sub_title || ""}
                            invalid={
                              validation1.touched.property_sub_title && validation1.errors.property_sub_title ? true : false
                            }
                          />
                          {validation1.touched.property_sub_title && validation1.errors.property_sub_title ? (
                            <FormFeedback type="invalid">{validation1.errors.property_sub_title}</FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col md={4} xs={12}>
                        <div className="mb-3">
                          <label className="form-label">Address :</label>
                          <Input 
                            name="property_address" 
                            type="text" 
                            placeholder={'Enter Address'}
                            onChange={validation1.handleChange}
                            onBlur={validation1.handleBlur}
                            value={validation1.values.property_address || ""}
                            invalid={
                              validation1.touched.property_address && validation1.errors.property_address ? true : false
                            }
                          />
                          {validation1.touched.property_address && validation1.errors.property_address ? (
                            <FormFeedback type="invalid">{validation1.errors.property_address}</FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col md={4} xs={12}>
                        <div className="mb-3">
                          <label className="form-label">Select Status :</label>
                          <select className="form-select" name="status" value={validation1.values.status} onChange={(e) => validation1.setValues({ ...validation1.values, status: e.target.value })}>
                            <option value="Enable">Enable</option>
                            <option value="Disable">Disable</option>
                          </select>
                          {validation1.touched.status && validation1.errors.status ? (
                            <FormFeedback type="invalid">{validation1.errors.status}</FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col md={4} xs={12}>
                        <div className="mb-3">
                          <label className="form-label">Select Property Status :</label>
                          <select className="form-select" name="property_status" value={validation1.values.property_status} onChange={(e) => validation1.setValues({ ...validation1.values, property_status: e.target.value })}>
                            <option value="open">Open</option>
                            <option value="pre-reserve">Pre Reserve</option>
                            <option value="under-study">Under Study</option>
                            <option value="funded">Funded</option>
                          </select>
                          {validation1.touched.property_status && validation1.errors.property_status ? (
                            <FormFeedback type="invalid">{validation1.errors.property_status}</FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col md={4} xs={12}>
                        <div className="mb-3">
                          <label className="form-label">Latitude :</label>
                          <Input 
                            name="latitude" 
                            type="text" 
                            placeholder={'Enter Latitude'}
                            onChange={validation1.handleChange}
                            onBlur={validation1.handleBlur}
                            value={validation1.values.latitude|| ""}
                            invalid={
                              validation1.touched.latitude && validation1.errors.latitude ? true : false
                            }
                          />
                          {validation1.touched.latitude && validation1.errors.latitude ? (
                            <FormFeedback type="invalid">{validation1.errors.latitude}</FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col md={4} xs={12}>
                        <div className="mb-3">
                          <label className="form-label">Longitude :</label>
                          <Input 
                            name="longitude" 
                            type="text" 
                            placeholder={'Enter Longitude'}
                            onChange={validation1.handleChange}
                            onBlur={validation1.handleBlur}
                            value={validation1.values.longitude|| ""}
                            invalid={
                              validation1.touched.longitude && validation1.errors.longitude ? true : false
                            }
                          />
                          {validation1.touched.longitude && validation1.errors.longitude ? (
                            <FormFeedback type="invalid">{validation1.errors.longitude}</FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col xs={12}>
                        <div className="mb-3">
                          <label className="form-label">Description :</label>
                          <JoditEditor
                            value={validation1.values.property_description}
                            onChange={handleDescriptionChange}
                            config={editorConfig}
                          />
                          {validation1.touched.property_description && validation1.errors.property_description ? (
                            <FormFeedback type="invalid">{validation1.errors.property_description}</FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col xs={12}>
                        <div className="mb-3">
                          <label className="form-label">Impact :</label>
                          <JoditEditor
                            value={validation1.values.property_impact}
                            onChange={handleImpactChange}
                            config={editorConfig}
                          />
                          {validation1.touched.property_impact && validation1.errors.property_impact ? (
                            <FormFeedback type="invalid">{validation1.errors.property_impact}</FormFeedback>
                          ) : null} 
                        </div>
                        <div className="mb-3">
                          <div className="d-flex justify-content-between align-items-center">
                            <label className="form-label">Current Impact Sheet:</label>
                            <button
                              type="button"
                              onClick={e => setStandardModal2(true)}
                              className="btn btn-primary"
                            >
                              Update Impact Sheet
                            </button>
                          </div>
                          <div className="mt-2">
                            <div className="d-flex align-items-center">
                              <i className="bx bx-file mr-2"></i>
                              <a href={impactDoc} target="_blank" rel="noopener noreferrer">
                                <span>{validation5.values.impact_document_name}</span>
                              </a>
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col xs={12}>
                        <div className="mb-3">
                          <label className="form-label">Developer :</label>
                          <JoditEditor
                            value={validation1.values.property_developer}
                            onChange={handleDeveloperChange}
                            config={editorConfig}
                          />
                          {validation1.touched.property_developer && validation1.errors.property_developer ? (
                            <FormFeedback type="invalid">{validation1.errors.property_developer}</FormFeedback>
                          ) : null} 
                        </div>
                      </Col>
                    </div>
                    <button type="button" 
                      id="submit1"
                      onClick={(e) => {
                        e.preventDefault();
                        handleSubmit();
                        validation1.handleSubmit();
                        return false;
                      }}
                    className="btn btn-primary me-2">Update</button>
                    <Link to="/property" className="btn btn-light">Cancel</Link>
                  </Col>
                </CardBody>
              </Card>

              <Card>
                <CardBody>
                  <div className="mb-4 h4 card-title">Property Images</div>
                  <Col xs="12">
                    <div className="row mb-3">
                      <Col lg={5} md={12} xs={12}>
                        <div className="mb-3">
                          <label className="form-label">Cover image : </label>
                          <div className="input-group">
                            <Input type="file" className="form-control fileUpload" aria-describedby="submit4" aria-label="Upload" accept="image/png, image/jpeg, image/jpg" onChange={saveCoverFile} />
                            <button className="btn btn-primary fileUpload" type="button" id="submit4" onClick={(e) => handleUploadCoverImage()}>Upload</button>
                          </div>
                          <label style={{color: 'red', marginTop: '0.5rem'}}>
                              Image perfect size is 1920 * 1080
                          </label>
                        </div>
                      </Col>
                      <Col xs={12}>
                        {CoverImageURL}
                      </Col>
                      <Col lg={5} md={12} xs={12}>
                        <div className="mb-3">
                          <label className="form-label">Image Gallery : </label>
                          <div className="input-group">
                            <input type="file" className="form-control fileUpload" aria-describedby="submit3" aria-label="Upload" accept="image/png, image/jpeg, image/jpg" onChange={saveFile} />
                            <button className="btn btn-primary fileUpload" type="button" id="submit3" onClick={(e) => handleUploadImage()}>Upload</button>
                          </div>
                          <label style={{color: 'red', marginTop: '0.5rem'}}>
                              Image perfect size is 1920 * 1080
                          </label>
                        </div>
                      </Col>
                      <Col xs={12}>
                        {ImageGallery}
                      </Col>
                    </div>
                  </Col>
                </CardBody>
              </Card>

              <Card>
                <CardBody>
                  <div className="mb-4 h4 card-title">Site Information</div>
                  <Col xs="12">
                    <div className="row mb-3">
                    <Col md={4} xs={12}>
                        <div className="mb-3">
                          <label className="form-label">Website :</label>
                          <Input
                            name="property_website" 
                            type="text" 
                            placeholder={'Enter Website '}
                            onChange={validation3.handleChange}
                            onBlur={validation3.handleBlur}
                            value={validation3.values.property_website || ""}
                            invalid={
                              validation3.touched.property_website && validation3.errors.property_website ? true : false
                            }
                          />
                          {validation3.touched.property_website && validation3.errors.property_website ? (
                            <FormFeedback type="invalid">{validation3.errors.property_website}</FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col md={4} xs={12}>
                        <div className="mb-3">
                          <label className="form-label">Instagram :</label>
                          <Input
                            name="property_instagram" 
                            type="text" 
                            placeholder={'Enter Instagram'}
                            onChange={validation3.handleChange}
                            onBlur={validation3.handleBlur}
                            value={validation3.values.property_instagram || ""}
                            invalid={
                              validation3.touched.property_instagram && validation3.errors.property_instagram ? true : false
                            }
                          />
                          {validation3.touched.property_instagram && validation3.errors.property_instagram ? (
                            <FormFeedback type="invalid">{validation3.errors.property_instagram}</FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                    </div>
                    <button type="button" 
                      id="submit3"
                      onClick={(e) => {
                        e.preventDefault();
                        validation3.handleSubmit();
                        return false;
                      }}
                    className="btn btn-primary me-2">Update</button>
                    <Link to="/property" className="btn btn-light">Cancel</Link>
                  </Col>
                </CardBody>
              </Card>

              <Card>
                <CardBody>
                  <div className="mb-4 h4 card-title">Token Information</div>
                  <Col xs="12">
                    <div className="row mb-3">
                      <Col md={4} xs={12}>
                        <div className="mb-3 position-relative inbuilt">
                          <label className="form-label">Token Price	:</label>
                          <Input
                            name="token_price"
                            type="text" 
                            placeholder={'Enter Token Price'}
                            onChange={validation2.handleChange}
                            onBlur={validation2.handleBlur}
                            value={validation2.values.token_price || ""}
                            invalid={
                              validation2.touched.token_price && validation2.errors.token_price ? true : false
                            }
                          />
                          {validation2.touched.token_price && validation2.errors.token_price ? (
                            <FormFeedback type="invalid">{validation2.errors.token_price}</FormFeedback>
                          ) : null}
                          <span className="euro-default">€</span>
                        </div>
                      </Col>
                      <Col md={4} xs={12}>
                        <div className="mb-3 position-relative">
                          <label className="form-label">Total Token	:</label>
                          <Input
                            name="total_token"
                            type="text" 
                            placeholder={'Enter Total Token'}
                            onChange={validation2.handleChange}
                            onBlur={validation2.handleBlur}
                            value={validation2.values.total_token || ""}
                            invalid={
                              validation2.touched.total_token && validation2.errors.total_token ? true : false
                            }
                          />
                          {validation2.touched.total_token && validation2.errors.total_token ? (
                            <FormFeedback type="invalid">{validation2.errors.total_token}</FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col md={4} xs={12}>
                        <div className="mb-3 position-relative inbuilt">
                          <label className="form-label">Minimum Investment Allocation	:</label>
                          <Input 
                            name="minimum_investment_allocation"
                            type="text" 
                            placeholder={'Enter Minimum Investment Allocation'}
                            onChange={validation2.handleChange}
                            onBlur={validation2.handleBlur}
                            value={validation2.values.minimum_investment_allocation || ""}
                            invalid={
                              validation2.touched.minimum_investment_allocation && validation2.errors.minimum_investment_allocation ? true : false
                            }
                          />
                          {validation2.touched.minimum_investment_allocation && validation2.errors.minimum_investment_allocation ? (
                            <FormFeedback type="invalid">{validation2.errors.minimum_investment_allocation}</FormFeedback>
                          ) : null}
                          <span className="euro-default">€</span>
                        </div>
                      </Col>
                      <Col md={4} xs={12}>
                        <div className="mb-3 position-relative">
                          <label className="form-label">Lock in Period No	:</label>
                          <Input
                            name="lock_in_period_no"
                            type="text" 
                            placeholder={'Enter Lock in Period No'}
                            onChange={validation2.handleChange}
                            onBlur={validation2.handleBlur}
                            value={validation2.values.lock_in_period_no || ""}
                            invalid={
                              validation2.touched.lock_in_period_no && validation2.errors.lock_in_period_no ? true : false
                            }
                          />
                          {validation2.touched.lock_in_period_no && validation2.errors.lock_in_period_no ? (
                            <FormFeedback type="invalid">{validation2.errors.lock_in_period_no}</FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col md={4} xs={12}>
                        <div className="mb-3">
                          <label className="form-label">Select Lock in Period :</label>
                          <select className="form-select" name="lock_in_period" value={validation2.values.lock_in_period} onChange={(e) => validation2.setValues({ ...validation2.values, lock_in_period: e.target.value })}>
                            <option value="year">Year</option>
                            <option value="month">Month</option>
                            <option value="day">Day</option>
                          </select>
                          {validation2.touched.lock_in_period && validation2.errors.lock_in_period ? (
                            <FormFeedback type="invalid">{validation2.errors.lock_in_period}</FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col md={4} xs={12}>
                        <div className="mb-3 position-relative inbuilt">
                          <label className="form-label">Profitability	:</label>
                          <Input
                            name="profitability"
                            type="text" 
                            placeholder={'Enter Profitability'}
                            onChange={validation2.handleChange}
                            onBlur={validation2.handleBlur}
                            value={validation2.values.profitability || ""}
                            invalid={
                              validation2.touched.profitability && validation2.errors.profitability ? true : false
                            }
                          />
                          {validation2.touched.profitability && validation2.errors.profitability ? (
                            <FormFeedback type="invalid">{validation2.errors.profitability}</FormFeedback>
                          ) : null}
                          <span className="euro-default">%</span>
                        </div>
                      </Col>
                    </div>
                    <button type="button" 
                      id="submit2"
                      onClick={(e) => {
                        e.preventDefault();
                        validation2.handleSubmit();
                        return false;
                      }}
                    className="btn btn-primary me-2">Update</button>
                    <Link to="/property" className="btn btn-light">Cancel</Link>
                  </Col>
                </CardBody>
              </Card>


            </Col>
          </Row>
        </Container >
      </div >

      <Modal
        isOpen={StandardModal2}
        backdrop={"static"}
        centered
        className="transation"
      >
        <div>
          <div className="modal-header">
            <h5 className="modal-title mt-0">Update Impact Sheet</h5>
            <button
              type="button"
              onClick={() => setStandardModal2(false)}
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <ModalBody>
            <div className="mb-3">
              <label className="form-label mt-3">Select New Impact Sheet:</label>
              <div className="input-group">
                <input
                  type="file"
                  className="form-control fileUpload"
                  aria-describedby="submit5"
                  aria-label="Upload"
                  accept=".pdf, .doc, .docx, .xls, .xlsx, .txt"
                  onChange={saveImpactFile}
                />
                <button
                  className="btn btn-primary fileUpload"
                  type="button"
                  id="submit5"
                  onClick={e => handleImpactUploadDoc()}
                >
                  Upload
                </button>
              </div>
            </div>
            <div className="mb-3">
              <label className="form-label">Impact Sheet Name:</label>
              <Input
                name="impact_document_name"
                type="text"
                placeholder={"Document Name"}
                onChange={e =>
                  validation5.setValues({
                    ...validation5.values,
                    impact_document_name: e.target.value,
                  })
                }
                onBlur={validation5.handleBlur}
                value={validation5.values.impact_document_name || ""}
                invalid={
                  validation5.touched.impact_document_name &&
                  validation5.errors.impact_document_name
                    ? true
                    : false
                }
              />
              {validation5.touched.impact_document_name &&
              validation5.errors.impact_document_name ? (
                <FormFeedback type="invalid">
                  {validation5.errors.impact_document_name}
                </FormFeedback>
              ) : null}
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              id="submit6"
              onClick={e => {
                e.preventDefault()
                validation5.handleSubmit()
                return false
              }}
              type="button"
              color="primary"
            >
              Update
            </Button>
            <Button
              type="button"
              color="light"
              onClick={() => setStandardModal2(false)}
            >
              Cancel
            </Button>
          </ModalFooter>
        </div>
      </Modal>
    </React.Fragment >
  );
};

export default withTranslation()(Edit_Property);
